import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    styled,
    SxProps,
    TextField,
    Theme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { forwardRef } from "react";

const SearchInputBase = styled(TextField)(({ theme }) => ({
    "& .MuiOutlinedInput-notchedOutline": {
        borderRight: 0,
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
    },
    "&": {
        width: "100%",
    },
}));

const SearchInputButton = styled(Button)(() => ({
    "&": {
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
}));

interface ISearchEditProps {
    label?: string;
    placeholder?: string;
    value?: any;
    sx?: SxProps<Theme>;
    onSearch?: (searchPhrase: string) => void;
    onSeachClear?: () => void;
    onChange?: (e: any) => void;
}

const SearchEdit = forwardRef((props: ISearchEditProps, ref) => {
    const emitOnSearch = (): void => {
        if (!props.onSearch) return;

        props.onSearch(props.value);
    };

    const emitOnChange = (event: any) => {
        if (!props.onChange) return;

        props.onChange(event);
    };

    return (
        <form
            style={{ width: "100%" }}
            onSubmit={(e) => {
                e.preventDefault();
                emitOnSearch();
            }}
        >
            <Box sx={{ display: "inline-flex", width: "100%", ...props.sx }}>
                <SearchInputBase
                    placeholder={props.placeholder}
                    label={props.label}
                    size="small"
                    inputRef={ref}
                    value={props.value}
                    onChange={(event) => emitOnChange(event)}
                    InputProps={
                        props.value !== "" && props.onSeachClear
                            ? {
                                  endAdornment: (
                                      <InputAdornment position="end">
                                          <IconButton
                                              size="small"
                                              onClick={() => {
                                                  if (props.onSeachClear) {
                                                      props.onSeachClear();
                                                  }
                                              }}
                                              edge="end"
                                          >
                                              <ClearIcon fontSize="small" />
                                          </IconButton>
                                      </InputAdornment>
                                  ),
                              }
                            : undefined
                    }
                />

                <SearchInputButton
                    variant="contained"
                    type="submit"
                    // onClick={() => emitOnSearch()}
                >
                    <SearchIcon />
                </SearchInputButton>
            </Box>
        </form>
    );
});

export default SearchEdit;
